import { AcceptanceDocData } from '@/api/theHive/notices/types';
import { Box, Grid, Typography } from '@mui/material';
import { useCallback, useRef } from 'react';

import { DocumentCard } from '../DocumentCard';
import {
  Container,
  ContentBox,
  ScrollableGrid,
  SkeletonCard,
  SkeletonCardWrapper,
  SkeletonLabel,
} from './styles';

const SKELETON_KEYS = ['sk-a', 'sk-b', 'sk-c'];

interface DocsSectionProps {
  data: AcceptanceDocData[];
  isLoading: boolean;
}

export function DocsSection({
  data,
  isLoading,
}: DocsSectionProps): JSX.Element {
  const scrollableGridRef = useRef<HTMLDivElement>(null);

  const handleDownload = useCallback((url: string): void => {
    window.open(url, '_blank');
  }, []);

  const renderContent = (): JSX.Element => {
    if (isLoading) {
      return (
        <ContentBox>
          {SKELETON_KEYS.map((key) => (
            <SkeletonCardWrapper key={key}>
              <SkeletonLabel variant="rectangular" />
              <SkeletonCard variant="rectangular" />
            </SkeletonCardWrapper>
          ))}
        </ContentBox>
      );
    }

    if (data.length === 0) {
      return (
        <Box mt={2}>
          <Typography>
            Nenhum documento para credenciamento foi encontrado
          </Typography>
        </Box>
      );
    }

    return (
      <ContentBox>
        {data.map((doc) => (
          <Box key={doc.id} maxWidth={330}>
            <DocumentCard
              name={doc.name}
              fileName={doc.original_filename}
              fileSize={doc.file_size ?? undefined}
              onDownload={
                doc.download_url
                  ? () => handleDownload(doc.download_url)
                  : undefined
              }
            />
          </Box>
        ))}
      </ContentBox>
    );
  };

  return (
    <Container item container xs={12}>
      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography fontSize={21}>Documentos para credenciamento</Typography>
      </Grid>
      <ScrollableGrid item container mt={3} ref={scrollableGridRef}>
        {renderContent()}
      </ScrollableGrid>
    </Container>
  );
}
